import React, { useEffect, useState } from "react";
import {
  Tag,
  Check,
  X,
  Percent,
  DollarSign,
  Building2,
  Calculator,
  CreditCard,
  Calendar,
  Gift,
} from "lucide-react";
import Pagelayout from "../../components/Pagelayout";
import { useNavigate } from "react-router-dom";
import "./payrollPayheadStyle.css";
import { useDispatch, useSelector } from "react-redux";
import { listPayHeadApi } from "../../parollAPIs";
import { filterEnum } from "../../../../filter/filterEnum";
import { calculationTypeOption, categoryOptions } from "../../payrollEnums";
import { setPaginationData, setSingleViewData } from "../../payrollSlice";

const Badge = ({ children, className }) => (
  <span className={`new-pyh-cmpt__badge ${className}`}>{children}</span>
);

// export const Switch = ({ checked, className }) => (
//   <label className={`new-pyh-cmpt__switch ${className}`}>
//     <input
//       type="checkbox"
//       checked={checked}
//       className="new-pyh-cmpt__switch-input"
//       onChange={() => {}}
//     />
//     <span className="new-pyh-cmpt__switch-slider"></span>
//   </label>
// );

const PayHeadCard = ({ data, handleCardClick }) => {
  const getCategoryConfig = (category) => {
    const configs = {
      BASIC: {
        bgClass: "new-pyh-cmpt__card--blue",
        textClass: "new-pyh-cmpt__text--blue",
        icon: DollarSign,
      },
      ALLOWANCE: {
        bgClass: "new-pyh-cmpt__card--purple",
        textClass: "new-pyh-cmpt__text--purple",
        icon: Percent,
      },
      DEDUCTION: {
        bgClass: "new-pyh-cmpt__card--red",
        textClass: "new-pyh-cmpt__text--red",
        icon: Calculator,
      },
      COMMISSION: {
        bgClass: "new-pyh-cmpt__card--green",
        textClass: "new-pyh-cmpt__text--green",
        icon: Percent,
      },
      BONUS: {
        bgClass: "new-pyh-cmpt__card--cyan",
        textClass: "new-pyh-cmpt__text--cyan",
        icon: DollarSign,
      },
      REIMBURSEMENTS: {
        bgClass: "new-pyh-cmpt__card--yellow",
        textClass: "new-pyh-cmpt__text--yellow",
        icon: CreditCard,
      },
      "LEAVE ENCASHMENT": {
        bgClass: "new-pyh-cmpt__card--orange",
        textClass: "new-pyh-cmpt__text--orange",
        icon: Calendar,
      },
      BENEFITS: {
        bgClass: "new-pyh-cmpt__card--teal",
        textClass: "new-pyh-cmpt__text--teal",
        icon: Gift,
      },
    };

    return (
      configs[category] || {
        bgClass: "new-pyh-cmpt__card--gray",
        textClass: "new-pyh-cmpt__text--gray",
        icon: Tag,
      }
    );
  };

  const config = getCategoryConfig(data.category);
  const CategoryIcon = config.icon;

  const getFieldIcon = (fieldKey) => {
    if (fieldKey.includes("amount") || fieldKey.includes("percentage"))
      return DollarSign;
    if (fieldKey.includes("account")) return Building2;
    if (fieldKey.includes("calculation")) return Calculator;
    return null;
  };

  return (
    <div
      className={`new-pyh-cmpt__card ${config.bgClass}`}
      onClick={() => handleCardClick(data)}
    >
      <div className="new-pyh-cmpt__card-header">
        <div className="new-pyh-cmpt__header-content">
          <div className="new-pyh-cmpt__category">
            <CategoryIcon size={18} className={config.textClass} />
            <Badge className={`${config.textClass} ${config.bgClass}`}>
              {data.category}
            </Badge>
          </div>
          <div className="new-pyh-cmpt__status">
            {/* <span
              className={`new-pyh-cmpt__status-text ${
                data.active ? "new-pyh-cmpt__status-text--active" : ""
              }`}
            >
              {data.active ? (
                <Check size={14} className="new-pyh-cmpt__status-icon" />
              ) : (
                <X size={14} className="new-pyh-cmpt__status-icon" />
              )}
              {data.active ? "Active" : "Inactive"}
            </span> */}
            {/* <Switch
              checked={data.active}
              className="new-pyh-cmpt__switch--small"
            /> */}
          </div>
        </div>
      </div>

      <div className="new-pyh-cmpt__card-content">
        <div className="new-pyh-cmpt__name-container">
          <h3 className="new-pyh-cmpt__name">{data.name}</h3>
        </div>

        <div className="new-pyh-cmpt__separator" />

        <div className="new-pyh-cmpt__fields">
          {Object.entries(data.fields || {}).map(([key, value]) => {
            const FieldIcon = getFieldIcon(key);
            return (
              <div key={key} className="new-pyh-cmpt__field">
                <span className="new-pyh-cmpt__field-label">
                  {FieldIcon && (
                    <FieldIcon size={14} className="new-pyh-cmpt__field-icon" />
                  )}
                  {key.replace(/_/g, " ").toUpperCase()}
                </span>
                <span
                  className={`new-pyh-cmpt__field-value ${
                    key.includes("amount")
                      ? "new-pyh-cmpt__field-value--amount"
                      : ""
                  }`}
                >
                  {value}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const PayrollPayHead = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleCreatePayHead = () => navigate("create");
  // redux store
  const { listData, filterData, paginationData, searchInput } = useSelector(
    (state) => state.payrollSlice
  );
  const [formattedData, setFormattedData] = useState([]);

  useEffect(() => {
    dispatch(setSingleViewData(null));
  }, [dispatch]);

  // handle search ,filter and pagination

  // filter options
  const filterOptions = [filterEnum.CATEGORY];

  // handle onClick card
  const handleCardClick = (data) => {
    // console.log(data)
    navigate(`create`, {
      state: { _id: data?._id },
    });
  };

  //initial rendering
  useEffect(() => {
    if (listData) {
      dispatch(
        setPaginationData({
          currentPage: paginationData?.currentPage || 1,
          totalPages: listData?.totalCount || 0,
        })
      );

      const formattedData = listData?.data?.map((data) => {
        const calculationType =
          calculationTypeOption.find((res) => res.value === data.calculationType)
            ?.key ?? "";
      
        return {
          _id: data._id,
          category: data.category,
          name: data.name,
          fields: {
            calculation_type: calculationType,
            [calculationType === "Fixed" ? "amount" : "percentage"]: data.amountOrPerc,
            expense_account: data.expAccnt,
          },
        };
      });
      
      setFormattedData(formattedData);
    }
  }, [listData]);

  useEffect(() => {
    listPayHeadApi({
      body: {
        page: paginationData.currentPage || 1,
        limit: 12,
        search: searchInput || "",
        category:
          filterData?.category?.map((item) => item?.value).join(",") || "",
      },
    });
  }, [filterData, paginationData.currentPage, searchInput]);

  return (
    <Pagelayout
      pageName="Pay Head"
      headerLayout={1}
      handleCreateBtn={handleCreatePayHead}
      filterOptions={filterOptions}
      categoryOptions={Object.values(categoryOptions).map((item) => ({
        value: item,
        label: item,
      }))}
      pagination={paginationData.totalPages > 1 ? true : false}
    >
     <div className="new-pyh-cmpt">
  <div className="new-pyh-cmpt__grid">
    {formattedData && formattedData.length > 0 ? (
      formattedData?.map((payHead, index) => (
        <PayHeadCard
          key={index}
          data={payHead}
          handleCardClick={handleCardClick}
        />
      ))
    ) : (
      <div className="no-data-container">
        <div className="no-data-icon">📊</div>
        <p className="no-data-text">No data found</p>
        {/* <button className="retry-btn" onClick={handleRetry}>Try Again</button> */}
      </div>
    )}
  </div>
</div>

    </Pagelayout>
  );
};

export default PayrollPayHead;
